const secJcamp2 = `
##TITLE=Spectrum
##JCAMP-DX=5.00 $$ chemotion-converter-app (0.1.0)
##DATA TYPE=SIZE EXCLUSION CHROMATOGRAPHY
##DATA CLASS=NTUPLES
##ORIGIN=
##OWNER=
##XUNITS=G/MOL
##YUNITS=ARBITRARY UNITS
##FIRSTX=1.17562E+3
##LASTX=3.82890E+4
##MINX=1175.62
##MAXX=38289.0
##MINY=0.0
##MAXY=2.84221
##NPOINTS=376
##FIRSTY=3.82806E-16
##XUNITS=G/MOL
##YUNITS=ARBITRARY UNITS
##XYDATA=(XY..XY)
1.17562E+3, 3.82806E-16
1.18659E+3, 0.00000E+0
1.19766E+3, 0.00000E+0
1.20884E+3, 0.00000E+0
1.22012E+3, 0.00000E+0
1.23151E+3, 0.00000E+0
1.24300E+3, 0.00000E+0
1.25460E+3, 0.00000E+0
1.26631E+3, 0.00000E+0
1.27812E+3, 0.00000E+0
1.29005E+3, 0.00000E+0
1.30209E+3, 0.00000E+0
1.31424E+3, 0.00000E+0
1.32651E+3, 0.00000E+0
1.33889E+3, 0.00000E+0
1.35138E+3, 0.00000E+0
1.36399E+3, 0.00000E+0
1.37672E+3, 0.00000E+0
1.38957E+3, 0.00000E+0
1.40254E+3, 0.00000E+0
1.41563E+3, 0.00000E+0
1.42884E+3, 0.00000E+0
1.44217E+3, 0.00000E+0
1.45563E+3, 0.00000E+0
1.46922E+3, 0.00000E+0
1.48293E+3, 0.00000E+0
1.49677E+3, 0.00000E+0
1.51073E+3, 0.00000E+0
1.52483E+3, 0.00000E+0
1.53906E+3, 0.00000E+0
1.55343E+3, 0.00000E+0
1.56792E+3, 0.00000E+0
1.58255E+3, 0.00000E+0
1.59732E+3, 0.00000E+0
1.61223E+3, 0.00000E+0
1.62728E+3, 0.00000E+0
1.64246E+3, 0.00000E+0
1.65779E+3, 0.00000E+0
1.67326E+3, 0.00000E+0
1.68888E+3, 0.00000E+0
1.70464E+3, 0.00000E+0
1.72055E+3, 0.00000E+0
1.73660E+3, 0.00000E+0
1.75281E+3, 0.00000E+0
1.76917E+3, 0.00000E+0
1.78568E+3, 0.00000E+0
1.80234E+3, 0.00000E+0
1.81916E+3, 0.00000E+0
1.83614E+3, 0.00000E+0
1.85327E+3, 0.00000E+0
1.87057E+3, 0.00000E+0
1.88802E+3, 0.00000E+0
1.90564E+3, 0.00000E+0
1.92343E+3, 0.00000E+0
1.94138E+3, 0.00000E+0
1.95950E+3, 0.00000E+0
1.97778E+3, 0.00000E+0
1.99624E+3, 0.00000E+0
2.01487E+3, 0.00000E+0
2.03367E+3, 0.00000E+0
2.05265E+3, 0.00000E+0
2.07181E+3, 0.00000E+0
2.09114E+3, 0.00000E+0
2.11066E+3, 0.00000E+0
2.13035E+3, 0.00000E+0
2.15023E+3, 0.00000E+0
2.17030E+3, 0.00000E+0
2.19055E+3, 0.00000E+0
2.21100E+3, 0.00000E+0
2.23163E+3, 0.00000E+0
2.25246E+3, 0.00000E+0
2.27348E+3, 0.00000E+0
2.29469E+3, 0.00000E+0
2.31611E+3, 0.00000E+0
2.33772E+3, 0.00000E+0
2.35954E+3, 0.00000E+0
2.38156E+3, 0.00000E+0
2.40379E+3, 0.00000E+0
2.42622E+3, 0.00000E+0
2.44886E+3, 0.00000E+0
2.47171E+3, 0.00000E+0
2.49478E+3, 0.00000E+0
2.51806E+3, 0.00000E+0
2.54156E+3, 0.00000E+0
2.56528E+3, 0.00000E+0
2.58922E+3, 0.00000E+0
2.61338E+3, 0.00000E+0
2.63777E+3, 0.00000E+0
2.66239E+3, 0.00000E+0
2.68723E+3, 0.00000E+0
2.71231E+3, 0.00000E+0
2.73762E+3, 0.00000E+0
2.76317E+3, 0.00000E+0
2.78896E+3, 0.00000E+0
2.81499E+3, 0.00000E+0
2.84126E+3, 0.00000E+0
2.86777E+3, 0.00000E+0
2.89454E+3, 0.00000E+0
2.92155E+3, 0.00000E+0
2.94881E+3, 0.00000E+0
2.97633E+3, 0.00000E+0
3.00411E+3, 0.00000E+0
3.03214E+3, 0.00000E+0
3.06044E+3, 0.00000E+0
3.08900E+3, 0.00000E+0
3.11783E+3, 0.00000E+0
3.14692E+3, 0.00000E+0
3.17629E+3, 0.00000E+0
3.20593E+3, 0.00000E+0
3.23585E+3, 0.00000E+0
3.26605E+3, 0.00000E+0
3.29653E+3, 0.00000E+0
3.32729E+3, 0.00000E+0
3.35835E+3, 0.00000E+0
3.38969E+3, 0.00000E+0
3.42132E+3, 0.00000E+0
3.45325E+3, 0.00000E+0
3.48547E+3, 0.00000E+0
3.51800E+3, 0.00000E+0
3.55083E+3, 0.00000E+0
3.58397E+3, 0.00000E+0
3.61742E+3, 0.00000E+0
3.65118E+3, 0.00000E+0
3.68525E+3, 0.00000E+0
3.71964E+3, 0.00000E+0
3.75435E+3, 0.00000E+0
3.78939E+3, 0.00000E+0
3.82475E+3, 0.00000E+0
3.86045E+3, 0.00000E+0
3.89647E+3, 0.00000E+0
3.93284E+3, 0.00000E+0
3.96954E+3, 0.00000E+0
4.00658E+3, 0.00000E+0
4.04398E+3, 0.00000E+0
4.08171E+3, 0.00000E+0
4.11981E+3, 0.00000E+0
4.15825E+3, 0.00000E+0
4.19706E+3, 0.00000E+0
4.23623E+3, 0.00000E+0
4.27576E+3, 0.00000E+0
4.31566E+3, 0.00000E+0
4.35594E+3, 0.00000E+0
4.39659E+3, 0.00000E+0
4.43762E+3, 2.91229E-2
4.47903E+3, 6.66612E-2
4.52083E+3, 1.00687E-1
4.56302E+3, 1.40419E-1
4.60560E+3, 2.10693E-1
4.64859E+3, 3.25575E-1
4.69197E+3, 4.33328E-1
4.73575E+3, 4.71069E-1
4.77995E+3, 5.04271E-1
4.82456E+3, 5.72306E-1
4.86958E+3, 6.85252E-1
4.91503E+3, 7.85563E-1
4.96089E+3, 8.39692E-1
5.00719E+3, 8.86562E-1
5.05392E+3, 9.23235E-1
5.10108E+3, 9.85608E-1
5.14869E+3, 1.02684E+0
5.19674E+3, 1.12228E+0
5.24523E+3, 1.25091E+0
5.29418E+3, 1.32789E+0
5.34359E+3, 1.40906E+0
5.39346E+3, 1.46067E+0
5.44379E+3, 1.49559E+0
5.49459E+3, 1.53567E+0
5.54587E+3, 1.56554E+0
5.59763E+3, 1.56935E+0
5.64987E+3, 1.62651E+0
5.70259E+3, 1.70969E+0
5.75581E+3, 1.78628E+0
5.80952E+3, 1.84763E+0
5.86374E+3, 1.88030E+0
5.91846E+3, 1.96495E+0
5.97369E+3, 2.05242E+0
6.02944E+3, 2.08014E+0
6.08571E+3, 2.08676E+0
6.14250E+3, 2.12827E+0
6.19983E+3, 2.23273E+0
6.25769E+3, 2.27171E+0
6.31609E+3, 2.25426E+0
6.37503E+3, 2.30253E+0
6.43452E+3, 2.37918E+0
6.49457E+3, 2.44187E+0
6.55518E+3, 2.46747E+0
6.61635E+3, 2.47152E+0
6.67810E+3, 2.47463E+0
6.74042E+3, 2.51218E+0
6.80333E+3, 2.56991E+0
6.86682E+3, 2.59237E+0
6.93090E+3, 2.61649E+0
6.99558E+3, 2.65108E+0
7.06086E+3, 2.66817E+0
7.12676E+3, 2.67673E+0
7.19327E+3, 2.69412E+0
7.26040E+3, 2.70330E+0
7.32815E+3, 2.72159E+0
7.39654E+3, 2.75603E+0
7.46557E+3, 2.76802E+0
7.53524E+3, 2.77519E+0
7.60556E+3, 2.80137E+0
7.67654E+3, 2.82599E+0
7.74818E+3, 2.83461E+0
7.82048E+3, 2.83483E+0
7.89347E+3, 2.83457E+0
7.96713E+3, 2.83175E+0
8.04148E+3, 2.83332E+0
8.11653E+3, 2.83380E+0
8.19227E+3, 2.82309E+0
8.26872E+3, 2.82251E+0
8.34589E+3, 2.81789E+0
8.42378E+3, 2.81621E+0
8.50239E+3, 2.80949E+0
8.58174E+3, 2.82302E+0
8.66182E+3, 2.83626E+0
8.74266E+3, 2.84221E+0
8.82425E+3, 2.83384E+0
8.90660E+3, 2.81124E+0
8.98972E+3, 2.81539E+0
9.07361E+3, 2.75215E+0
9.15829E+3, 2.71305E+0
9.24375E+3, 2.73246E+0
9.33002E+3, 2.71216E+0
9.41709E+3, 2.67941E+0
9.50497E+3, 2.65316E+0
9.59368E+3, 2.64522E+0
9.68321E+3, 2.61297E+0
9.77357E+3, 2.56363E+0
9.86478E+3, 2.56115E+0
9.95684E+3, 2.56953E+0
1.00498E+4, 2.52110E+0
1.01435E+4, 2.45788E+0
1.02382E+4, 2.42190E+0
1.03338E+4, 2.38616E+0
1.04302E+4, 2.33474E+0
1.05275E+4, 2.29746E+0
1.06258E+4, 2.33490E+0
1.07249E+4, 2.30446E+0
1.08250E+4, 2.20207E+0
1.09261E+4, 2.14223E+0
1.10280E+4, 2.06547E+0
1.11309E+4, 2.01649E+0
1.12348E+4, 1.99259E+0
1.13397E+4, 1.95109E+0
1.14455E+4, 1.89678E+0
1.15523E+4, 1.84782E+0
1.16601E+4, 1.81569E+0
1.17689E+4, 1.79131E+0
1.18787E+4, 1.72642E+0
1.19896E+4, 1.65675E+0
1.21015E+4, 1.58447E+0
1.22144E+4, 1.52889E+0
1.23284E+4, 1.47503E+0
1.24435E+4, 1.38972E+0
1.25596E+4, 1.33677E+0
1.26768E+4, 1.27745E+0
1.27951E+4, 1.22704E+0
1.29145E+4, 1.20398E+0
1.30350E+4, 1.16894E+0
1.31567E+4, 1.10843E+0
1.32795E+4, 1.07294E+0
1.34034E+4, 1.02948E+0
1.35285E+4, 9.63049E-1
1.36547E+4, 9.29727E-1
1.37822E+4, 8.75290E-1
1.39108E+4, 8.38479E-1
1.40406E+4, 8.10030E-1
1.41716E+4, 7.47325E-1
1.43039E+4, 6.62462E-1
1.44374E+4, 5.82267E-1
1.45721E+4, 5.14707E-1
1.47081E+4, 4.60347E-1
1.48453E+4, 4.17789E-1
1.49839E+4, 4.08896E-1
1.51237E+4, 4.03280E-1
1.52649E+4, 3.96594E-1
1.54073E+4, 3.60915E-1
1.55511E+4, 2.98794E-1
1.56962E+4, 2.36079E-1
1.58427E+4, 1.70678E-1
1.59906E+4, 1.14090E-1
1.61398E+4, 1.18475E-1
1.62904E+4, 6.97513E-2
1.64424E+4, 5.78262E-2
1.65959E+4, 5.43940E-2
1.67508E+4, 1.67532E-2
1.69071E+4, 0.00000E+0
1.70649E+4, 0.00000E+0
1.72241E+4, 0.00000E+0
1.73849E+4, 0.00000E+0
1.75471E+4, 0.00000E+0
1.77108E+4, 0.00000E+0
1.78761E+4, 0.00000E+0
1.80430E+4, 0.00000E+0
1.82113E+4, 0.00000E+0
1.83813E+4, 0.00000E+0
1.85528E+4, 0.00000E+0
1.87260E+4, 0.00000E+0
1.89007E+4, 0.00000E+0
1.90771E+4, 0.00000E+0
1.92551E+4, 0.00000E+0
1.94348E+4, 0.00000E+0
1.96162E+4, 0.00000E+0
1.97993E+4, 0.00000E+0
1.99840E+4, 0.00000E+0
2.01705E+4, 0.00000E+0
2.03588E+4, 0.00000E+0
2.05488E+4, 0.00000E+0
2.07405E+4, 0.00000E+0
2.09341E+4, 0.00000E+0
2.11295E+4, 0.00000E+0
2.13266E+4, 0.00000E+0
2.15257E+4, 0.00000E+0
2.17266E+4, 0.00000E+0
2.19293E+4, 0.00000E+0
2.21340E+4, 0.00000E+0
2.23405E+4, 0.00000E+0
2.25490E+4, 0.00000E+0
2.27594E+4, 0.00000E+0
2.29718E+4, 0.00000E+0
2.31862E+4, 0.00000E+0
2.34026E+4, 0.00000E+0
2.36210E+4, 0.00000E+0
2.38414E+4, 0.00000E+0
2.40639E+4, 0.00000E+0
2.42885E+4, 0.00000E+0
2.45152E+4, 0.00000E+0
2.47439E+4, 0.00000E+0
2.49749E+4, 0.00000E+0
2.52079E+4, 0.00000E+0
2.54432E+4, 0.00000E+0
2.56806E+4, 0.00000E+0
2.59203E+4, 0.00000E+0
2.61622E+4, 0.00000E+0
2.64063E+4, 0.00000E+0
2.66528E+4, 0.00000E+0
2.69015E+4, 0.00000E+0
2.71525E+4, 0.00000E+0
2.74059E+4, 0.00000E+0
2.76617E+4, 0.00000E+0
2.79198E+4, 0.00000E+0
2.81804E+4, 0.00000E+0
2.84434E+4, 0.00000E+0
2.87088E+4, 0.00000E+0
2.89767E+4, 0.00000E+0
2.92472E+4, 0.00000E+0
2.95201E+4, 0.00000E+0
2.97956E+4, 0.00000E+0
3.00737E+4, 0.00000E+0
3.03543E+4, 0.00000E+0
3.06376E+4, 0.00000E+0
3.09235E+4, 0.00000E+0
3.12121E+4, 0.00000E+0
3.15034E+4, 0.00000E+0
3.17974E+4, 0.00000E+0
3.20941E+4, 0.00000E+0
3.23936E+4, 0.00000E+0
3.26959E+4, 0.00000E+0
3.30011E+4, 0.00000E+0
3.33090E+4, 0.00000E+0
3.36199E+4, 0.00000E+0
3.39336E+4, 0.00000E+0
3.42503E+4, 0.00000E+0
3.45699E+4, 0.00000E+0
3.48926E+4, 0.00000E+0
3.52182E+4, 0.00000E+0
3.55468E+4, 0.00000E+0
3.58786E+4, 0.00000E+0
3.62134E+4, 0.00000E+0
3.65514E+4, 0.00000E+0
3.68925E+4, 0.00000E+0
3.72368E+4, 0.00000E+0
3.75843E+4, 1.81792E-2
3.79350E+4, 2.61575E-2
3.82890E+4, 0.00000E+0
##END=$$ End of the data block


`;

export default secJcamp2;
